export default function formatPrice(sum) {
    return new Intl.NumberFormat("ru-RU").format(parseInt(sum));
}
;
